import React from "react";
import ReactDOM from "react-dom/client";
// CL-PRIVACY-HARDENING-001: Inter and Plus Jakarta Sans are self-hosted (OFL-1.1, bundled
// woff2/woff, font-display: swap) — the same weights the Google Fonts @import used to load.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "@fontsource/oxanium/600.css";
import "@/index.css";
import "@/styles/world-theme.css";
import App from "@/App";

// "World" theme renders dark regardless of the class, but set it explicitly so
// any token consumer keyed on .dark resolves correctly.
document.documentElement.classList.add("dark");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
